import dayjs from 'dayjs';

export const dateToSeconds = (dateSlug) => {
  const formattedDate = new Date(dateSlug);
  const systemDate = new Date();

  return ((formattedDate.getTime() / 1000) - (systemDate.getTime() / 1000));
};

// Since we are not displaying seconds, there are edge cases on the last transitions of day, hour and min.
// eg: '2 days' to '1 day, 23 hours and 59 mins' or '1 day and 23 hours' to '1day, 22 hours and 59 mins'
// Formatted string will not display any 0 values - initially uses ',' as default seperator ...
// ... & replaces the last instance of ',' with 'and'. Finally, adjusts space after all ','
const formatTimerString = (str) => {
  str = str.trim().replace(/(,$)/g, '');
  const lastIndexOfSeparator = str.lastIndexOf(',');

  str = lastIndexOfSeparator > -1
    ? `${str.substring(0, lastIndexOfSeparator)} and ${str.substring(lastIndexOfSeparator + 1)}`
    : str;

  return str.replace(/,/g, ', ');
};

export const secondsToDhm = (seconds) => {
  const days = Math.floor(seconds / (24 * 60 * 60));
  const hours = Math.floor((seconds % (24 * 60 * 60)) / 3600);
  const minutes = Math.floor((seconds % (60 * 60)) / 60);
  const showMinutes = (days === 0 && hours >= 0 && minutes > 0);

  const dayLabel = days > 0 ? `${days} ${days === 1 ? 'day' : 'days'},` : '';
  const hourLabel = hours > 0 ? `${hours} ${hours === 1 ? 'hour' : 'hours'},` : '';
  const minuteLabel = showMinutes ? `${minutes} ${minutes === 1 ? 'min' : 'mins'}` : '';

  return formatTimerString(`${dayLabel}${hourLabel}${minuteLabel}`);
};

export const fetchExpiryDate = ({ creationDate, daysToExpire }) => {
  const expiryDate = new Date(creationDate);
  expiryDate.setDate(expiryDate.getDate() + daysToExpire);
  return (expiryDate.toISOString());
};

export const dateToMonths = (dateString) => {
  const currentDate = new Date();

  const timeDifference = dayjs(currentDate).diff(dateString, 'month');
  return timeDifference;
};
